import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class PresenceService {
  private readonly http = inject(HttpClient);
  private readonly router = inject(Router);
  private readonly auth = inject(AuthService);

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => this.beat(false));
    window.setInterval(() => this.beat(false), 20000);
    window.addEventListener('pagehide', () => this.beat(true));
  }

  private beat(away: boolean): void {
    if (!this.auth.signedIn()) {
      return;
    }
    const path = this.router.url.split('?')[0].slice(0, 180) || '/';
    if (away) {
      const token = localStorage.getItem('liiji.token');
      if (!token) {
        return;
      }
      void fetch('/api/presence', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ path, away: true }),
        keepalive: true,
      });
      return;
    }
    this.http.post('/api/presence', { path, away: false }).subscribe({ error: () => undefined });
  }
}
